import gql from 'graphql-tag';

export const lookupVisitorWatchlist = gql`
  query LookupVisitorWatchlist(
    $organizationId: String!
    $lookupVisitor: LookupVisitorInput!
    $tenantId: String
  ) {
    lookupVisitorWatchlist(
      organizationId: $organizationId
      lookupVisitor: $lookupVisitor
      tenantId: $tenantId
    ) {
      matches {
        watchlistRuleId
        visitorWatchlistId
        approvalRequired
      }
    }
  }
`;
